module.exports = "/images/porte-monnaie.png?9cd5a8b87ff45a55c1565757dc83b28e";